<template>
  <section class="game">
    <app-modal @passRef="mod = $event" :result="risultato"></app-modal>
    <section class="row">
      <div class="w-50 columns">
        <h1 class="text-center text-white text-responsive">YOU</h1>
        <div class="healthbar">
          <div
            class="healthbar text-center"
            style="background-color: green; margin: 0; color: white"
            :style="{ width: playerHealth + '%' }"
          >
            {{ playerHealth }}
          </div>
        </div>
        <div class="stats" v-if="!gameIsRunning">
          <div>ATTACK: 0</div>
          <div>SPEED: 0</div>
          <div>ACCURACY: 50</div>
        </div>
        <div class="stats" v-else>
          <div>ATTACK: {{ playerAttackDamage }}</div>
          <div>SPEED: {{ playerSpeed }}</div>
          <div>ACCURACY: {{ playerAccuracy }}</div>
        </div>
      </div>
      <div class="w-50 columns">
        <h1 class="text-center text-white text-responsive">FABIO</h1>
        <div class="healthbar">
          <div
            class="healthbar text-center"
            style="background-color: green; margin: 0; color: white"
            :style="{ width: monsterHealth + '%' }"
          >
            {{ monsterHealth }}
          </div>
        </div>
        <div class="stats" v-if="!gameIsRunning">
          <div>ATTACK: 0</div>
          <div>SPEED: 0</div>
          <div>ACCURACY: 100</div>
        </div>
        <div class="stats" v-else>
          <div>ATTACK: {{ monsterAttackDamage }}</div>
          <div>SPEED: {{ monsterSpeed }}</div>
          <div>ACCURACY: {{ monsterAccuracy }}</div>
        </div>
      </div>
    </section>
    <section class="row controls" v-if="!gameIsRunning">
      <div class="w-100 columns">
        <button class="game-easy" @click="gameEasy">START GAME (EASY)</button>
        <button class="game-normal" @click="gameNormal">
          START GAME (NORMAL)
        </button>
        <button class="game-hard" @click="gameHard">START GAME (HARD)</button>
      </div>
      <div
        class="text-white text-center game-description p-3 p-md-4 p-lg-5 text-responsive"
      >
        This is a little game I created as an exercise with Javascript. I also
        used Vue 2 as framework. In fact, the entirety of this web application
        is made with Vue 2. I learned it watching a course on Udemy. The
        difficulty setting changes your starting HP, speed and attack damage
        (hint: if your speed is higher than mine, I might waste some turns to
        buff myself!).
      </div>
    </section>
    <section class="row controls" v-else>
      <div class="w-100 columns">
        <button class="attack" @click="normalAttack">
          ATTACK<span>Deal a normal amount of damage</span>
        </button>
        <button class="special-attack" @click="specialAttack">
          SPECIAL ATTACK<span
            >Does from a very little to a huge amount of damage</span
          >
        </button>
        <button class="risky-attack" @click="riskyAttack">
          RISKY ATTACK<span>Does massive damage, but it may miss</span>
        </button>
        <button class="attack-up" @click="attackUp">
          ATK+2<span>Raise damage dealt by 2</span>
        </button>
        <button class="speed-up" @click="speedUp">
          SPEED+2<span>Increase speed to attack first</span>
        </button>
        <button class="accuracy-up" @click="accUp">
          ACCURACY+10<span>Increase accuracy for risky attack</span>
        </button>
        <button class="heal" @click="heal">
          HEAL<span>Heals some damage received</span>
        </button>
        <button class="give-up" @click="giveUp">
          GIVE UP<span>Stop playing</span>
        </button>
      </div>
    </section>
    <section class="row log" v-if="turns.length > 0">
      <div class="w-100 columns">
        <ul class="pr-5 scrollable">
          <li
            v-for="turn in turns"
            :class="{
              'player-turn': turn.isPlayer,
              'monster-turn': !turn.isPlayer,
            }"
            :key="turn"
          >
            {{ turn.text }}
          </li>
        </ul>
      </div>
    </section>
  </section>
</template>

<script>
import Modal from "../components/Modal";

export default {
  components: {
    "app-modal": Modal,
  },
  data: function () {
    return {
      playerHealth: 100,
      playerMaxHealth: 100,
      monsterHealth: 100,
      playerAccuracy: 50,
      monsterAccuracy: 100,
      gameIsRunning: false,
      playerAttackDamage: 0,
      playerSpeed: 0,
      monsterAttackDamage: 0,
      monsterSpeed: 0,
      difficulty: "?",
      turns: [],
      mod: "",
      risultato: "won",
      modal: false,
      number: 3,
    };
  },
  methods: {
    showModal() {
      this.mod["my-modal"].show();
    },
    hideModal() {
      this.mod["my-modal"].hide();
    },
    toggleModal() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.mod["my-modal"].toggle("#toggle-btn");
    },
    capitalize: function (s) {
      if (typeof s !== "string") return "";
      return s.charAt(0).toUpperCase() + s.slice(1);
    },

    randomNumber: function (min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min);
    },

    startGame: function () {
      this.gameIsRunning = true;
      this.hideModal();
      this.monsterHealth = 100;
      this.monsterSpeed = 2;
      this.playerAccuracy = 50;
    },

    gameEasy: function () {
      this.startGame();
      this.playerMaxHealth = 115;
      this.playerHealth = this.playerMaxHealth;
      this.playerAttackDamage = 1;
      this.playerSpeed = 1;
      this.monsterAttackDamage = -1;
      this.difficulty = "Easy";
      this.turns = [
        { isPlayer: true, text: "Any feedback is deeply appreciated!" },
        { isPlayer: false, text: "Starting difficulty: " + this.difficulty },
        { isPlayer: false, text: "Fabio starting stats: " },
        {
          isPlayer: false,
          text:
            "Speed: " +
            this.monsterSpeed +
            ", Attack: " +
            this.monsterAttackDamage +
            ", HP: " +
            this.monsterHealth,
        },
        { isPlayer: true, text: "Your starting stats:" },
        {
          isPlayer: true,
          text:
            "Speed: " +
            this.playerSpeed +
            ", Attack: " +
            this.playerAttackDamage +
            ", HP: " +
            this.playerMaxHealth,
        },
      ];
    },

    gameNormal: function () {
      this.startGame();
      this.playerMaxHealth = 100;
      this.playerHealth = this.playerMaxHealth;
      this.playerAttackDamage = 0;
      this.playerSpeed = 0;
      this.monsterAttackDamage = 0;
      this.difficulty = "Normal";
      this.turns = [
        { isPlayer: true, text: "Any feedback is deeply appreciated!" },
        { isPlayer: false, text: "Starting difficulty: " + this.difficulty },
        { isPlayer: false, text: "Fabio starting stats: " },
        {
          isPlayer: false,
          text:
            "Speed: " +
            this.monsterSpeed +
            ", Attack: " +
            this.monsterAttackDamage +
            ", HP: " +
            this.monsterHealth,
        },
        { isPlayer: true, text: "Your starting stats:" },
        {
          isPlayer: true,
          text:
            "Speed: " +
            this.playerSpeed +
            ", Attack: " +
            this.playerAttackDamage +
            ", HP: " +
            this.playerMaxHealth,
        },
      ];
    },

    gameHard: function () {
      this.startGame();
      this.playerMaxHealth = 85;
      this.playerHealth = this.playerMaxHealth;
      this.playerAttackDamage = -1;
      this.playerSpeed = -1;
      this.monsterAttackDamage = 1;
      this.difficulty = "Hard";
      this.turns = [
        { isPlayer: true, text: "Any feedback is deeply appreciated!" },
        { isPlayer: false, text: "Starting difficulty: " + this.difficulty },
        { isPlayer: false, text: "Fabio starting stats: " },
        {
          isPlayer: false,
          text:
            "Speed: " +
            this.monsterSpeed +
            ", Attack: " +
            this.monsterAttackDamage +
            ", HP: " +
            this.monsterHealth,
        },
        { isPlayer: true, text: "Your starting stats:" },
        {
          isPlayer: true,
          text:
            "Speed: " +
            this.playerSpeed +
            ", Attack: " +
            this.playerAttackDamage +
            ", HP: " +
            this.playerMaxHealth,
        },
      ];
    },

    checkWin: function () {
      if (this.monsterHealth <= 0) {
        this.risultato = "won";
        console.log(this.risultato);
        this.showModal();

        console.log(this.risultato);
      } else if (this.playerHealth <= 0) {
        this.risultato = "lost";
        console.log(this.risultato);
        this.showModal();
      }
      return false;
    },

    checkTurnOrder: function (action) {
      if (this.playerSpeed > this.monsterSpeed) {
        action();
        setTimeout(() => {
          this.monsterTurn();
        }, 1000);
      } else {
        this.monsterTurn();
        setTimeout(() => {
          action();
        }, 1000);
      }
    },

    attack: function (min, max, type) {
      var damage = this.randomNumber(min, max);
      this.monsterHealth -= damage;
      this.turns.unshift({
        isPlayer: true,
        text: "You hit Fabio for " + damage + " damage with a " + type,
      });

      if (this.checkWin()) {
        return;
      }
    },

    normalAttack: function () {
      var yourTurn = () => {
        this.attack(
          this.playerAttackDamage + 4,
          this.playerAttackDamage + 11,
          "normal attack"
        );
      };
      this.checkTurnOrder(yourTurn);
    },

    specialAttack: function () {
      var yourTurn = () => {
        this.attack(0, this.playerAttackDamage + 17, "special attack");
      };
      this.checkTurnOrder(yourTurn);
    },

    riskyAttack: function () {
      var yourTurn = () => {
        var random = Math.random() * 100;
        if (random < this.playerAccuracy) {
          this.attack(
            this.playerAttackDamage + 17,
            this.playerAttackDamage + 18,
            "risky attack"
          );
        } else {
          this.turns.unshift({
            isPlayer: true,
            text: "Risky attack missed!",
          });
        }
      };
      this.checkTurnOrder(yourTurn);
    },

    statChange: function (stat, change, statNameDisplay, statName) {
      this[statName] = stat += change;
      this.turns.unshift({
        isPlayer: true,
        text:
          this.capitalize(statNameDisplay) +
          " stat raised by " +
          change +
          ". Current " +
          statNameDisplay +
          ": " +
          stat,
      });
    },

    attackUp: function () {
      var yourTurn = () =>
        this.statChange(
          this.playerAttackDamage,
          2,
          "attack",
          "playerAttackDamage"
        );
      this.checkTurnOrder(yourTurn);
    },

    speedUp: function () {
      var yourTurn = () => {
        this.statChange(this.playerSpeed, 2, "speed", "playerSpeed");
      };
      this.checkTurnOrder(yourTurn);
    },

    accUp: function () {
      var yourTurn = () => {
        this.statChange(this.playerAccuracy, 10, "accuracy", "playerAccuracy");
      };
      this.checkTurnOrder(yourTurn);
    },

    heal: function () {
      var yourTurn = () => {
        var random = this.randomNumber(10, 12);
        if (this.playerHealth + random <= this.playerMaxHealth) {
          this.playerHealth += 11;
          this.turns.unshift({
            isPlayer: true,
            text: "You heal yourself " + random + " HP",
          });
        } else {
          this.playerHealth = 100;
          this.turns.unshift({
            isPlayer: true,
            text: "You heal yourself completely",
          });
        }
      };
      this.checkTurnOrder(yourTurn);
    },

    giveUp: function () {
      this.gameIsRunning = false;
      this.hideModal();
    },

    monsterTurn: function () {
      if (this.playerSpeed >= this.monsterSpeed) {
        var random = Math.random() * 100;
        if (random < 50) {
          this.monsterBuff();
        } else {
          this.monsterAttack();
        }
      } else {
        this.monsterAttack();
      }
    },

    monsterAttack: function () {
      var damage = this.randomNumber(
        this.monsterAttackDamage + 6,
        this.monsterAttackDamage + 13
      );
      this.playerHealth -= damage;
      this.checkWin();
      this.turns.unshift({
        isPlayer: false,
        text: "Fabio hits You for " + damage + " damage",
      });
    },

    monsterBuff: function () {
      this.monsterSpeed += 1;
      this.monsterAttackDamage += 1;
      this.turns.unshift({
        isPlayer: false,
        text: "Fabio raises its attack damage and speed!",
      });
    },
  },
};
</script>

<style lang="scss">
.scrollable {
  height: 11rem;
  overflow: scroll;
}
.game-description {
  font-size: 2rem;
}

.text-responsive {
  font-size: 1.5rem;
  padding-top: 0.7rem;
}

@media (min-width: 510px) {
  .text-responsive {
    font-size: 2rem;
    padding-top: 0;
  }
}

button {
  font-size: 20px;
  background-color: #eee;
  padding: 12px;
  box-shadow: 0 1px 1px black;
  margin: 10px;
}

.healthbar {
  width: 80%;
  height: 40px;
  background-color: #eee;
  margin: auto;
  transition: width 500ms;
}

.stats {
  width: 80%;
  margin: auto;
  margin-top: 1rem;
  background-color: rgb(240, 240, 240);
  padding: 0.5rem 1rem;
  border-radius: 1rem;
  box-shadow: 0 1px 1px black;
}

.controls,
.log {
  margin-top: 30px;
  text-align: center;
  padding: 10px;
  border: 1px solid #ccc;
  box-shadow: 0px 3px 6px #ccc;
}

.turn {
  margin-top: 20px;
  margin-bottom: 20px;
  font-weight: bold;
  font-size: 22px;
}

.log ul {
  list-style: none;
  font-weight: bold;
  text-transform: uppercase;

  li {
    margin: 5px;
  }

  .player-turn {
    color: blue;
    background-color: #e4e8ff;
  }

  .monster-turn {
    color: red;
    background-color: #ffc0c1;
  }

  button {
    font-size: 20px;
    background-color: #eee;
    padding: 12px;
    box-shadow: 0 1px 1px black;
    margin: 10px;
  }
}

.game-easy {
  background-color: #afffb4;
  &:hover {
    background-color: #76ff7e;
  }
}

.game-normal {
  background-color: #fdb239;
  &:hover {
    background-color: #fd9c00;
  }
}

.game-hard {
  background-color: #ff9494;
  &:hover {
    background-color: #e92e2e;
  }
}

.attack,
.speed-up,
.accuracy-up,
.risky-attack,
.attack-up,
.special-attack,
.heal,
.give-up {
  position: relative;
  span {
    display: none;
    position: absolute;
    color: #fff;
    background: #000;
    padding: 5px;
    font-size: 1rem;
    z-index: 1;
  }

  &:hover {
    span {
      display: block;
      text-align: center;
    }
  }
}

.attack {
  background-color: #ff7367;
  &:hover {
    background-color: #ff3f43;
  }
}

.speed-up {
  background-color: #fffb00;
  &:hover {
    background-color: #ffd900;
  }
}

.accuracy-up {
  background-color: rgb(255, 115, 213);
  color: white;
  &:hover {
    background-color: rgb(253, 59, 195);
  }
}

.risky-attack {
  background-color: rgb(0, 26, 255);
  color: white;
  &:hover {
    background-color: rgb(61, 81, 255);
  }
}

.attack-up {
  background-color: rgb(47, 47, 47);
  color: white;
  &:hover {
    background-color: rgb(0, 0, 0);
  }
}

.special-attack {
  background-color: #ffaf4f;
  &:hover {
    background-color: #ff9a2b;
  }
}

.heal {
  background-color: #aaffb0;

  &:hover {
    background-color: #76ff7e;
  }
}

.give-up {
  background-color: #ffffff;
  &:hover {
    background-color: #c7c7c7;
  }
}
</style>
